import { ReactNode } from "react";

export interface INavbarToggle {
  children?: ReactNode;
  className: string;
  onClick?: () => void;
}
function NavbarToggle({ children,className,onClick}: INavbarToggle) {
  return (
    <button className={`navbar-toggler collapsed ${className}`} onClick={onClick}>
      {children}
    </button>
  );

}

export default NavbarToggle;
